import Splide from '@splidejs/splide';
import BigPicture from 'bigpicture'


export default class SingleProjects {
  gallerySlider() {
    const slider = new Splide('.projects-carousel', {
      type: 'loop',
      perPage: 3,
      pagination: false,
      arrows: false,
      perMove: 1,
      gap: '16px',
      breakpoints: {
        768: {
          perPage: 1
        },
        1200: {
          perPage: 2,
        },
      }
    }).mount();
    const arrowPrev = document.querySelector('.arrow-left');
    const arrowNext = document.querySelector('.arrow-right');
    if (document.contains(arrowPrev)) {
      arrowPrev.addEventListener('click', () => {
        slider.go('<');
      })
    }
    if (document.contains(arrowNext)) {
      arrowNext.addEventListener('click', () => {
        slider.go('>');
      })
    }
    const scrollContainer = document.querySelector(".projects-carousel-desktop");
    if (document.contains(scrollContainer)) {
      scrollContainer.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollContainer.scrollLeft += evt.deltaY;
      });
    }

  }

  youtubeLightbox() {
    const items = document.querySelectorAll('.youtube');
    for (const item of items) {
      item.addEventListener('click', (e) => {
        BigPicture({
          el: e.target,
          ytSrc: e.target.getAttribute('ytSrc'),
        })
      })
    }
  }

  render() {
    this.gallerySlider();
    this.youtubeLightbox()
  }
}

function Load() {
  const load = new SingleProjects();
  load.render();
}


document.addEventListener('DOMContentLoaded', Load, {passive: true});


// WEBPACK FOOTER //
// ./resources/assets/js/single/single-projects.js